(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["focal-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mf-gallery-progress')) {
  customElements.define('mf-gallery-progress', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.closest('gallery-list').querySelector('.gallery__list-wrapper');
      this.bar = this.querySelector('.gallery__progress-bar');
      this.update = () => {
        const total = this.scroller.scrollWidth;
        const visible = this.scroller.clientWidth;
        if (!total) return;
        const ratio = Math.min(1, visible / total);
        const offset = Math.min(total - visible, Math.max(0, Math.abs(this.scroller.scrollLeft)));
        const position = getComputedStyle(this.scroller).direction === 'rtl'
          ? (1 - ratio) * 100 - offset / total * 100
          : offset / total * 100;
        this.bar.style.setProperty('--mf-thumb-width', ratio * 100 + '%');
        this.bar.style.setProperty('--mf-thumb-left', position + '%');
      };
      this.scroller.addEventListener('scroll', this.update, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.scroller);
      this.observer.observe(this.scroller.querySelector('.gallery__list'));
      this.scroller.addEventListener('load', this.update, true);
      this.update();
    }
    disconnectedCallback() {
      this.observer.disconnect();
      this.scroller.removeEventListener('scroll', this.update);
      this.scroller.removeEventListener('load', this.update, true);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-home-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-collection-grid')) {
    customElements.define('mf-collection-grid', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const controller = new AbortController();
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const signal = controller.signal;
        const items = [];
        const autoplay = this.dataset.autoplay === 'true';
        const sync = item => {
          const playing = !item.video.paused;
          item.button.classList.toggle('is-playing', playing);
          item.button.setAttribute('aria-label', playing ? item.button.dataset.pause : item.button.dataset.play);
        };
        const eligible = item => !signal.aborted && !document.hidden && item.visible && !item.userPaused && (item.userPlay || (autoplay && !motion.matches));
        const clearRetry = item => { clearTimeout(item.retryTimer); item.retryTimer = null; };
        const play = item => {
          if (!eligible(item) || item.pending || !item.video.paused) return;
          item.video.defaultMuted = true;
          item.video.muted = true;
          item.video.playsInline = true;
          item.video.preload = 'auto';
          item.video.autoplay = autoplay && !motion.matches;
          item.pending = true;
          const failed = () => {
            item.pending = false;
            sync(item);
            if (!eligible(item) || item.retries >= 3 || item.retryTimer) return;
            item.retryTimer = setTimeout(() => {
              item.retryTimer = null;
              item.retries += 1;
              play(item);
            }, [300, 1000, 2500][item.retries]);
          };
          try {
            Promise.resolve(item.video.play()).then(() => {
              item.pending = false;
              clearRetry(item);
              if (!eligible(item)) item.video.pause();
              sync(item);
            }, failed);
          } catch (error) { failed(); }
        };
        const refresh = item => {
          if (eligible(item)) play(item);
          else { clearRetry(item); item.video.autoplay = false; item.video.pause(); }
        };
        this.querySelectorAll('.mf-collections__media').forEach(media => {
          const video = media.querySelector('video');
          const button = media.querySelector('.mf-collections__playback');
          if (!video || !button) return;
          const item = { video, button, visible: false, userPaused: false, userPlay: false, pending: false, retries: 0, retryTimer: null };
          items.push(item);
          video.controls = false;
          video.defaultMuted = true;
          video.muted = true;
          video.playsInline = true;
          button.hidden = false;
          video.addEventListener('play', () => sync(item), { signal });
          video.addEventListener('pause', () => sync(item), { signal });
          video.addEventListener('loadeddata', () => refresh(item), { signal });
          video.addEventListener('canplay', () => refresh(item), { signal });
          button.addEventListener('click', () => {
            if (video.paused) { item.userPaused = false; item.userPlay = true; item.retries = 0; clearRetry(item); play(item); }
            else { item.userPaused = true; item.userPlay = false; refresh(item); }
          }, { signal });
          sync(item);
        });
        const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const item = items.find(candidate => candidate.video === entry.target);
            if (!item) return;
            const wasVisible = item.visible;
            item.visible = entry.isIntersecting && entry.intersectionRatio >= .15;
            if (item.visible && !wasVisible) item.retries = 0;
            refresh(item);
          });
        }, { threshold: [0, .15] }) : null;
        items.forEach(item => { if (observer) observer.observe(item.video); else { item.visible = true; refresh(item); } });
        const resume = () => items.forEach(item => { item.retries = 0; refresh(item); });
        document.addEventListener('visibilitychange', resume, { signal });
        window.addEventListener('pageshow', resume, { signal });
        const retryAfterGesture = event => {
          if (event.target.closest && event.target.closest('.mf-collections__playback')) return;
          items.forEach(item => { if (item.video.paused && eligible(item)) { item.retries = 0; clearRetry(item); play(item); } });
        };
        document.addEventListener('touchend', retryAfterGesture, { signal, passive: true });
        document.addEventListener('click', retryAfterGesture, { signal });
        motion.addEventListener('change', () => { items.forEach(item => { item.userPlay = false; refresh(item); }); }, { signal });
        this.cleanup = () => { controller.abort(); if (observer) observer.disconnect(); items.forEach(item => { clearRetry(item); item.video.autoplay = false; item.video.pause(); }); };
      }
      disconnectedCallback() { if (this.cleanup) this.cleanup(); this.cleanup = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-home-press"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-press-strip')) {
    customElements.define('mf-press-strip', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.mf-press__viewport');
        this.track = this.querySelector('.mf-press__track');
        this.group = this.querySelector('.mf-press__group');
        this.button = this.querySelector('.mf-press__pause');
        if (!this.group) return;
        this.abort = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 740px)');
        this.onMotion = () => this.schedule();
        this.motion.addEventListener('change', this.onMotion);
        this.mobile.addEventListener('change', this.onMotion);
        this.resize = new ResizeObserver(() => this.schedule());
        this.resize.observe(this);
        this.visibility = new IntersectionObserver(entries => {
          this.classList.toggle('is-offscreen', !entries[0].isIntersecting);
        });
        this.visibility.observe(this);
        this.button?.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          this.button.setAttribute('aria-pressed', String(paused));
        }, { signal: this.abort.signal });
        this.addEventListener('focusin', event => {
          this.classList.toggle('is-link-focused', Boolean(event.target.closest('a.mf-press__logo')));
        }, { signal: this.abort.signal });
        this.addEventListener('focusout', event => {
          this.classList.toggle('is-link-focused', Boolean(event.relatedTarget?.closest?.('a.mf-press__logo')));
        }, { signal: this.abort.signal });
        this.addEventListener('shopify:block:select', event => {
          this.selected = true;
          this.build();
          const item = event.target.closest('.mf-press__item');
          if (item) this.viewport.scrollLeft = item.offsetLeft - this.viewport.offsetLeft;
        }, { signal: this.abort.signal });
        this.addEventListener('shopify:block:deselect', () => {
          this.selected = false;
          this.schedule();
        }, { signal: this.abort.signal });
        this.build();
      }

      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.build());
      }

      copy(node) {
        const clone = node.cloneNode(true);
        clone.dataset.mfpCopy = '';
        clone.setAttribute('aria-hidden', 'true');
        [clone, ...clone.querySelectorAll('*')].forEach(element => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
          if (element.matches('a, button, [tabindex]')) element.setAttribute('tabindex', '-1');
        });
        return clone;
      }

      build() {
        if (!this.isConnected) return;
        this.querySelectorAll('[data-mfp-copy]').forEach(node => node.remove());
        this.classList.remove('is-animated');
        this.classList.toggle('is-editing', Boolean(this.selected));
        if (this.button) this.button.hidden = true;
        if (this.dataset.scrolling !== 'true' || this.motion.matches || this.selected) return;
        const items = Array.from(this.group.children);
        if (!items.length || this.clientWidth === 0) return;
        this.viewport.scrollLeft = 0;
        this.classList.add('is-animated');
        const originalWidth = this.group.getBoundingClientRect().width;
        if (originalWidth <= 0) {
          this.classList.remove('is-animated');
          return;
        }
        const repetitions = Math.max(1, Math.ceil(this.viewport.clientWidth / originalWidth));
        for (let i = 1; i < repetitions; i++) {
          items.forEach(item => this.group.append(this.copy(item)));
        }
        const distance = this.group.getBoundingClientRect().width;
        this.style.setProperty('--mfp-distance', `${distance}px`);
        const speed = this.mobile.matches ? Number(this.dataset.speedMobile) || 48 : Number(this.dataset.speed) || 24;
        this.style.setProperty('--mfp-duration', `${distance / Math.max(5, speed)}s`);
        this.track.append(this.copy(this.group));
        if (this.button) this.button.hidden = false;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.resize?.disconnect();
        this.visibility?.disconnect();
        this.abort?.abort();
        this.motion?.removeEventListener('change', this.onMotion);
        this.mobile?.removeEventListener('change', this.onMotion);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-landing-performance"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-performance')) {
    customElements.define('mf-performance', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const video = this.querySelector('video');
        const button = this.querySelector('.mf-performance__playback');
        if (!video || !button) return;
        const controller = new AbortController();
        const signal = controller.signal;
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let visible = false, userPaused = false, userPlay = false, pending = false, retries = 0, timer;
        const eligible = () => !signal.aborted && !document.hidden && visible && !userPaused && (userPlay || (this.dataset.autoplay === 'true' && !motion.matches));
        const sync = () => { button.classList.toggle('is-playing', !video.paused); button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause); };
        const play = () => {
          if (!eligible() || pending || !video.paused) return;
          video.defaultMuted = true; video.muted = true; video.playsInline = true; video.preload = 'auto';
          pending = true;
          const failed = () => {
            pending = false; sync();
            if (!eligible() || retries >= 3 || timer) return;
            timer = setTimeout(() => { timer = null; retries += 1; play(); }, [300, 1000, 2500][retries]);
          };
          try { Promise.resolve(video.play()).then(() => { pending = false; clearTimeout(timer); timer = null; if (!eligible()) video.pause(); sync(); }, failed); } catch (error) { failed(); }
        };
        const refresh = () => { if (eligible()) play(); else { clearTimeout(timer); timer = null; video.pause(); } };
        video.controls = false; video.muted = true; video.defaultMuted = true; video.playsInline = true; button.hidden = false;
        video.addEventListener('play', sync, { signal }); video.addEventListener('pause', sync, { signal });
        video.addEventListener('loadeddata', refresh, { signal }); video.addEventListener('canplay', refresh, { signal });
        button.addEventListener('click', () => { if (video.paused) { userPaused = false; userPlay = true; retries = 0; } else { userPaused = true; userPlay = false; } refresh(); }, { signal });
        const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => { visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .15; retries = 0; refresh(); }, { threshold: [0, .15] }) : null;
        if (observer) observer.observe(video); else { visible = true; refresh(); }
        const resume = () => { retries = 0; refresh(); };
        const gesture = event => { if (!button.contains(event.target) && video.paused) resume(); };
        document.addEventListener('visibilitychange', resume, { signal }); window.addEventListener('pageshow', resume, { signal });
        document.addEventListener('touchend', gesture, { signal, passive: true }); document.addEventListener('click', gesture, { signal });
        motion.addEventListener('change', () => { userPlay = false; refresh(); }, { signal });
        this.cleanup = () => { controller.abort(); clearTimeout(timer); if (observer) observer.disconnect(); video.pause(); };
        sync();
      }
      disconnectedCallback() { if (this.cleanup) this.cleanup(); this.cleanup = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-product-features-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mf-feature-video')) {
  customElements.define('mf-feature-video', class extends HTMLElement {
    connectedCallback() {
      this.screenQuery = matchMedia('(max-width: 749px)');
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.manualPaused = false;
      this.manualPlay = false;
      this.sync = () => this.updatePlayback();
      this.screenQuery.addEventListener('change', this.sync);
      this.motionQuery.addEventListener('change', this.sync);
      document.addEventListener('visibilitychange', this.sync);
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
        this.updatePlayback();
      }, {threshold: [0, .25]});
      this.visibilityObserver.observe(this);
    }
    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
      this.screenQuery?.removeEventListener('change', this.sync);
      this.motionQuery?.removeEventListener('change', this.sync);
      document.removeEventListener('visibilitychange', this.sync);
      this.video?.pause();
    }
    isActive() {
      return this.visible && !document.hidden && this.screenQuery.matches === (this.dataset.viewport === 'mobile');
    }
    updatePlayback() {
      if (this.isActive() && !this.video) {
        this.querySelector('[data-video-stage]').append(this.querySelector('template').content.cloneNode(true));
        this.video = this.querySelector('video');
        this.video.muted = true;
        this.button = this.querySelector('button');
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          this.manualPaused = !this.video.paused;
          this.manualPlay = this.video.paused;
          this.updatePlayback();
        });
        this.video.addEventListener('play', () => this.updateButton());
        this.video.addEventListener('pause', () => this.updateButton());
      }
      if (!this.video) return;
      if (this.shouldPlay()) {
        this.video.play().then(() => {
          if (!this.shouldPlay()) this.video.pause();
        }).catch(() => this.updateButton());
      } else {
        this.video.pause();
      }
      this.updateButton();
    }
    shouldPlay() {
      return this.isActive() && !this.manualPaused && (!this.motionQuery.matches || this.manualPlay);
    }
    updateButton() {
      const playing = !this.video.paused;
      this.button.setAttribute('aria-pressed', String(playing));
      this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
